import styled from 'styled-components';

import { cssBreakpoints } from 'theme';

export const CmsTileModalBackdrop = styled.div`
  position: fixed;
  z-index: 9000; /* must be < 9999 (login modal z-index) and > navbar z-index */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(54, 54, 54, 0.6);
`;

export const CmsTileModalContainer = styled.div`
  position: fixed;
  z-index: 9001; /* must be < 9999 (login modal z-index) and > navbar z-index */
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    overflow: auto;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 729px;
    height: 100%;
    align-items: center;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    overflow: hidden;
    width: calc(100% - 140px);
    max-width: 1573px;
    height: 791px;
    max-height: calc(100% - 140px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
  }
`;

export const TileModalDesktopArrowContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 130px;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const CmsTileModalContent = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
    align-items: center;
    overflow: auto;
    width: 100%;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    overflow: hidden;
  }
`;

export const CmsTileModalTwoColumns = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  padding-bottom: 58px;
  overflow: hidden;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    padding-left: 31px;
    padding-right: 31px;
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    justify-content: center;
    width: 100%;
    padding-left: 42px;
    padding-right: 42px;
  }
`;

export const CmsTileModalTwoColumnsContent = styled.div`
  display: flex;
  flex: 1;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
    max-width: 559px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    align-items: flex-start;
    justify-content: center;
  }
`;
